<template>
    <div v-if="folder.parent !== null" class="folderitem"
         :class="{ selected: (folder.id === selectedFolder) && (folderType === selectedType),
         selectable: folder.rights.indexOf('r') !== -1 }"
         @click.stop="selectFolder">
        <FontAwesomeIcon icon="chevron-right" @click.stop="$emit('toggle')" :class="iconClass"/>
        <div class="foldername" :title="displayName">
            {{displayName}}
        </div>
        <div class="tools" v-if="routeFolderType!=='z' && !specialFolder">
            <FontAwesomeIcon icon="cog" @click.stop="configFolder"/>
        </div>
        <span v-if="folder.unread > 0" class="foldercount">
            <b-badge variant="primary">{{unread}}</b-badge>
        </span>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { EventBus } from '@/event-bus';

export default {
  name: 'folderItem',
  components: { FontAwesomeIcon },
  props: {
    folder: Object,
    folderName: String,
    folderType: {
      type: String,
      default: ''
    },
    selectedType: String,
    selectedFolder: Number,
    isExpanded: {
      type: Boolean,
      default: false
    },
    showExpander: {
      type: Boolean,
      default: true
    },
    hasChildren: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectFolder() {
      if (this.folder.rights.indexOf('r') !== -1) {
        this.$router.push(`/${this.routeFolderType}/${this.folder.id}/1`).catch(e => {
          if (e.name === 'NavigationDuplicated') {
            EventBus.$emit('messageListRefresh', { folderId: this.folder.id });
          }
        });
        // this.$emit('select', [ this.folderName, this.folder, this.folderType ]);
      }
    },
    configFolder() {
      if (this.folder.rights.indexOf('r') !== -1) {
        this.$router.push(`/${this.routeFolderType}/${this.folder.id}/config`);
      }
    }
  },
  computed: {
    iconClass() {
      return [ 'foldericon',
        (this.hasChildren && this.showExpander) ? (this.isExpanded ? 'toggled' : '') : 'hideicon' ];
    },
    unread() {
      if (this.folder.unread > 1000) {
        return this.$t('folderList.unreadThousands', { unread: Math.floor(this.folder.unread / 1000) });
      } else {
        return this.folder.unread;
      }
    },
    routeFolderType() {
      if (this.folderType === 'F') {
        return 'f';
      } else {
        return 'n';
      }
    },
    displayName() {
      const key = `folderList.folders.${this.folderName}`;
      if (this.$i18n.i18next.exists(key)) {
        return this.$t(key);
      } else {
        return this.folder.dispName;
      }
    },
    specialFolder() {
      return !!this.folder.rights.match(/[oq]/);
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .folderitem {
        user-select: none;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        width: 100%;
        position: relative;
        &:hover {
            background-color: $hover-bg;
            &.selectable .tools {
                display: inline-block;
                position: absolute;
                right: 0;
                top: 0;
                height: 100%;
                padding: 0 5px;
                // cursor: pointer;
                z-index: 100;
            }
            .tools + .foldercount {
                opacity: 0;
            }
        }
        &.selected {
            background-color: $select-bg;
            outline: none; //$select-outline;
        }

        .foldername {
            display: inline-block;
            color: $gray-600;
            flex: 1;
            overflow-x: hidden;
            text-overflow: ellipsis;
        }
        .tools {
            display: none;
        }
        .foldercount {
            flex: 0 0 auto;
            margin-right: 3px;
            margin-top: -1px;
            cursor: pointer;
            transition: opacity 0.1s;
        }
        &.selectable{
            cursor: pointer;
            .foldername{
                color: $black;
            }
        }
    }

    .foldericon {
        transition: 0.2s;
        margin-right: 0.2em;
        cursor: pointer;
        flex: 0 0 20px;
    &.toggled {
         transform: rotate(90deg);
     }
    &.hideicon {
         opacity: 0;
     }
    }
</style>
